/** Shuffles visible product slots; Shopify still decides which products belong on each page. */
class SRandomProducts extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('[data-random-product-list]');
    if (!list) return;

    const url = new URL(window.location.href);
    const hasFilter = [...url.searchParams].some(([name, value]) => name.startsWith('filter.') && value.trim());
    const selectedSort = url.searchParams.get('sort_by');
    const hasCustomSort = selectedSort && selectedSort !== this.dataset.defaultSort;
    if (hasFilter || hasCustomSort) return;

    const products = [...list.children].filter((item) => item.dataset.productId);
    if (products.length < 2) return;

    const shuffled = [...products];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const other = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[other]] = [shuffled[other], shuffled[index]];
    }

    // Keep a returning shopper from seeing the same first card twice in a row.
    const key = `sahla:products:first:${url.pathname}:${this.dataset.randomKey || 'page'}:${url.searchParams.get('q') || ''}:${url.searchParams.get('page') || '1'}`;
    try {
      const previousFirst = sessionStorage.getItem(key);
      if (shuffled[0].dataset.productId === previousFirst) {
        [shuffled[0], shuffled[1]] = [shuffled[1], shuffled[0]];
      }
      sessionStorage.setItem(key, shuffled[0].dataset.productId);
    } catch {
      // Private browsing may disable storage; the fresh shuffle still works.
    }

    // Replace only product slots, leaving article and collection search hits in place.
    const slots = products.map((product) => {
      const marker = document.createComment('product slot');
      product.replaceWith(marker);
      return marker;
    });
    slots.forEach((slot, index) => slot.replaceWith(shuffled[index]));
  }
}

customElements.define('s-random-products', SRandomProducts);
